<template>
  <!-- {{ props.terrID }} -->
  <div class="relative">

    <div
      id="mapContainer"
      :style="{
        'height': props.height || (!screen.isMobile ? '100vh' : 'calc(100vh - 53px)')
      }"
    ></div>
    <MapLayerControls
      :isSatellite="isSatellite"
      :google="googleEnabled"
      position="bottom-left"
      @toggle-satellite="toggleSatellite"
      @toggle-google="toggleGoogle"
    />
    <div v-if="props.search" class="absolute search" >

          <div class="flex">
            <InputGroup>
              <InputText
                v-model="address"
                placeholder="Dirección"
                style="width: 80%"
              />
              <Button
                class="p-button-secondary"
                icon="pi pi-search"
                @click="buscar"
              />
              <Button
                class="p-button-secondary"
                :icon="locating ? 'pi pi-spin pi-spinner' : 'pi pi-map-marker'"
                :title="'Mi ubicación'"
                @click="geolocate"
                :disabled="locating"
              />
            </InputGroup>
          </div>
        </div>
  </div>
</template>

<script setup>
import {
  onMounted,
  onUnmounted,
  defineProps,
  defineEmits,
  watch,
  computed,
  defineExpose,
  ref
} from "vue";
import { useMapStore } from "@/store/map";
import { useMapPrefs } from "@/composables/useMapPrefs";
import { useMzNumbers } from "@/store/map/mzNumber";
import { useTerrLimit } from "@/store/map/terrLimit";
import { useScreenStore } from "@/store/useScreenStore";
import InputGroup from "primevue/inputgroup";
import MapLayerControls from "@/components/MapLayerControls.vue";

const screen = useScreenStore();
const m = useMapStore();
const { googleEnabled, setGoogleEnabled } = useMapPrefs();
const isSatellite = m.satellite;

// Controles directos en el mapa: al cambiar, re-aplican los tiles al mapa activo.
const toggleGoogle = () => {
  setGoogleEnabled(!googleEnabled.value);
  if (m.map.value) m.setTileLayer();
};
const toggleSatellite = () => m.toggleSatellite();
const mzNumbers = useMzNumbers();
const terrLimit = useTerrLimit();

const props = defineProps({
  center: {
    type: Array,
    default: null,
  },
  search: {
    type: Boolean,
    default: true,
  },
  terrID: {
    type: String,
    default: null,
  },
  editing: {
    type: Boolean,
    default: true,
  },
  mzDrag: {
    type: Boolean,
    default: false,
  },
  color: {
    type: Object,
    default: null,
  },
  saveCenter: {
    type: Boolean,
    default: true,
  },
  setPoint: {
    type: Boolean,
    default: false,
  },
  zoom: {
    type: String,
    default: "17",
  },
  height: {
    type: String,
    default: null,
  },
});
var numbers = [];
var activePoint = [];
const address = ref("");
const locating = ref(false);
let geoMarker = null;
let geoCircle = null;

const center = computed({
  get() {
    console.log("props.center", props.center, m.getStoreCenter())
   
    return props.center || m.getStoreCenter();
  },
  set(val) {
    m.setCenter(val);
  },
});

const buscar = () => {
  m.geocode(address.value);
};

const geolocate = () => {
  if (!navigator.geolocation) return;
  locating.value = true;
  navigator.geolocation.getCurrentPosition(
    (pos) => {
      locating.value = false;
      const lat = pos.coords.latitude;
      const lng = pos.coords.longitude;
      const accuracy = pos.coords.accuracy;

      if (geoMarker) m.map.value.removeLayer(geoMarker);
      if (geoCircle) m.map.value.removeLayer(geoCircle);

      const icon = m.L.divIcon({
        className: '',
        iconSize: [18, 18],
        iconAnchor: [9, 9],
        html: '<div style="width:18px;height:18px;border-radius:50%;background:#2563eb;border:3px solid #fff;box-shadow:0 0 6px rgba(37,99,235,.7)"></div>',
      });
      geoMarker = m.L.marker([lat, lng], { icon }).addTo(m.map.value).bindPopup('Tu ubicación').openPopup();
      geoCircle = m.L.circle([lat, lng], { radius: accuracy, color: '#2563eb', fillColor: '#93c5fd', fillOpacity: 0.2, weight: 1 }).addTo(m.map.value);
      m.map.value.flyTo([lat, lng], 17);
    },
    () => { locating.value = false; },
    { enableHighAccuracy: true, timeout: 10000 }
  );
};

const emit = defineEmits([
  "mapClick",
  "mapMoveend",
  "mapMoveend",
  "zoomstart",
  "zoomend",
  "ready",
  "dragendMz",
  "clickMz",
]);

onMounted(() => {
  console.log("MapaBase onMounted");
  let service = m.L.map("mapContainer", {
    scrollWheelZoom: false,
    zoomSnap: 0.25,
    zoomAnimation: false,
  }).setView(center.value, props.zoom);
  m.setMap(service);
  m.setTileLayer();
  m.map.value.on("click", function (e) {
    // console.log("props.setPoint", props.setPoint)
    emit("mapClick", e);
    if (!props.editing) return;
    if (props.setPoint) {
      activePoint.forEach((e) => {
        m.map.value.removeLayer(e);
      });
      activePoint = [];
      let icon = m.iconMarker[0];
      let marker = m.L.marker(e.latlng, { icon: icon }).addTo(m.map.value);
      activePoint.push(marker);
    }
  });
  var keydown = false;
  m.map.value.on("keydown", function (e) {
    if (keydown) return;
    keydown = true;
    m.map.value.scrollWheelZoom.enable();
  });
  m.map.value.on("keyup", function (e) {
    keydown = false;
    m.map.value.scrollWheelZoom.disable();
  });
  m.map.value.on("moveend", function (e) {
    emit("mapMoveend", e);
    let data = m.map.value.getBounds().getCenter();
    // console.log(data)
    if (props.saveCenter) center.value = [data.lat, data.lng];
  });
  m.map.value.on("zoomstart", function (e) {
    // console.log("zoomstart", e)

    emit("zoomstart", e);
    if (!props.editing) return;
    for (let i in numbers) {
      m.map.value.removeLayer(numbers[i]);
    }
  });
  m.map.value.on("zoomend", function (e) {
    emit("zoomend", e);
    if (!props.editing) return;
    setNumbers(mzNumbers.mzNumbers);
  });

  console.log("ready");
  emit("ready", {
    m: () => m,
    map: () => m.map.value,
  });
});

onUnmounted(() => {
  for (let i in numbers) {
    try { m.map.value?.removeLayer(numbers[i]); } catch {}
  }
  numbers = [];
  activePoint = [];
  if (geoMarker) { try { m.map.value?.removeLayer(geoMarker); } catch {} geoMarker = null; }
  if (geoCircle) { try { m.map.value?.removeLayer(geoCircle); } catch {} geoCircle = null; }
  try { m.map.value?.remove(); } catch {}
  m.setMap(null);
});

if (props.editing) {
  watch(
    mzNumbers,
    (state) => {
      //  console.log("state watch", state)
      setNumbers(state.mzNumbers);
    },
    { deep: true }
  );

  watch(
    props.color,
    (state) => {
      //  console.log("state watch", state)
      setNumbers(mzNumbers.mzNumbers);
    },
    { deep: true }
  );

  // review center
}



const setNumbers = (data) => {
  // console.log("setNumbers",data)
  // console.log('props.color', props.color)
  const colors = props.color
    ? `color: ${props.color.color}; background: ${props.color.backgroundColor}; border: ${props.color.backgroundColor}; `
    : "";
  for (let i in numbers) {
    m.map.value.removeLayer(numbers[i]);
  }
  numbers = [];
  for (let i in data) {
    if (!props.terrID && parseInt(i) === 0) continue;
    const nro = parseInt(i) === 0 ? props.terrID : i;
    const classCenter = parseInt(i) === 0 ? "manzana-marker-center" : "";
    // console.log('addnumber', nro);
    let icon = L.divIcon({
      className: "manzana-marker ",
      iconSize: null,
      html: `<div class="icon ${classCenter}" style="font-size: 1em; ${
        parseInt(i) === 0 ? "" : colors
      }">${nro}</div><div class="arrow" />`,
    });
    let mark = m.L.marker(data[i][0], { icon, draggable: true }).addTo(m.map.value);
    mark.on("dragend", function (e) {
      // console.log("dragend", e);
      emit("dragendMz", { e, i });
    });
    mark.on("click", function (e) {
      // console.log("click", e);
      emit("clickMz", { e, i });
    });
    numbers.push(mark);
  }
};

defineExpose({
  m,
});
</script>

<style scoped>
#mapContainer {
  width: 100%;
  height: 100vh;
  position: relative;
}

.search {
  top: 10px;
  right: 10px;
  z-index: 1000;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  background-color: rgba(255, 255, 255, 0.6);
}

</style>
